// AI学習用データ（media-ai-training-data）
export const MediaAiTrainingDataApiPath = {
  GET: '/api/sites/{site_id}/media/ai-training-data', // GET AI学習用データ取得
  UPDATE: '/api/sites/{site_id}/media/ai-training-data' // PUT AI学習用データ保存（upsert）
}

export type MediaAiTrainingDataApiPath =
  (typeof MediaAiTrainingDataApiPath)[keyof typeof MediaAiTrainingDataApiPath]

export interface GetMediaAiTrainingDataVars {
  site_id: number
}

// 保存は部分更新。送った項目だけが更新され、省いた項目は変更されない
// （記事HTML・共通ルールを別画面で編集するため、一方の保存で他方を消さない）。
// 空文字を明示的に送ると当該項目の削除になる。
export interface UpdateMediaAiTrainingDataVars {
  site_id: number
  article_html?: string
  restrictions?: string
}
